import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import Text from '../Text';
import TextField from "@mui/material/TextField";
import {InputAdornment} from "@mui/material";
import {useEffect, useState} from 'react';
import {ValidatorForm} from 'react-material-ui-form-validator';
import {api} from '../../maps/data.js';
import Divider from '@mui/material/Divider';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import {permissionsMap, USER_TYPES} from '../../maps/permissionsMap';
import styled from "styled-components";
import useZibi from "../../zibi/UseZibi";

const ClientSelectorWrapper = styled.div`
  margin: 20px 0 10px;
`;


export default function AlertDialog(props) {
    const {open, onClose} = props;
    const newUser = !Object.keys(open).length;

    const [clients, s_clients] = useState([]);
    const [sites, s_sites] = useState([]);
    const [selectedClient, s_selectedClient] = useState('');
    const [selectedSite, s_selectedSite] = useState('');
    const [email, s_email] = useState('');
    const [phone, s_phone] = useState("");
    const [name, s_name] = useState('');
    const [password, s_password] = useState('');
    const [confirm_password, s_confirm_password] = useState('');
    const [role, s_role] = useState('');

    const [user] = useZibi('user');

    const permissions = permissionsMap[user?.role?.[0]];
    const userAdd = permissions?.userAdd;
    const userRole = zibi.user.role[0];

    const save = async () => {
        await api({
            type: 'addUser',
            data: {
                email,
                name,
                phone: `+${phone}`,
                password,
                confirm_password,
                role,
                clientId: userRole === USER_TYPES.SITE_ADMIN ? user.clientId : selectedClient || null,
                siteId: selectedSite || null
            }
        });
        onClose();
    };

    useEffect(() => {
        if(userAdd?.getClients){
            getClients();
        }
    }, []);

    useEffect(() => {
        if(userAdd?.getSites){
            getSites();
        }
    }, []);

    const getClients = async () => {
        const res = await api({type: 'getClients'});
        s_clients(res);
    };

    const getSites = async () => {
        const res = await api({
            type: 'getSites',
            data: {
                clientId: user.clientId
            }
        });
        s_sites(res);
    };

    const allowAddUsersType = permissionsMap[userRole].allowAddUsersType;

    const isSaveDisabled = () => {
        let result = true;
        if (email && name && password && confirm_password && role) {
            result = false;
        }

        if (!result && role === USER_TYPES.CLIENT_ADMIN) {
            if (!selectedClient && userRole !== USER_TYPES.CLIENT_ADMIN) {
                result = true;
            }
        }

        if (!result && role === USER_TYPES.SITE_ADMIN) {
            if (!selectedSite && userRole !== USER_TYPES.SITE_ADMIN) {
                result = true;
            }
        }

        if(!result){
            switch (role) {
                case USER_TYPES.STORE_BOUNCER:
                case USER_TYPES.SITE_ADMIN:
                case USER_TYPES.STORE_SECURITY:
                    if (!phone) {
                        result = true;
                    }
                    break;
            }
        }

        return result;
    };

    let showPhone = false;
    switch (role) {
        case USER_TYPES.STORE_BOUNCER:
        case USER_TYPES.SITE_ADMIN:
        case USER_TYPES.STORE_SECURITY:
            showPhone = true;
          break;
    }

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <ValidatorForm
                onSubmit={save}
                onError={errors => console.log(errors)}>

                <DialogTitle id="alert-dialog-title">
                    {newUser ? <Tx>user.addUser.title</Tx> : <Tx>user.editUser.title</Tx>}
                </DialogTitle>
                <DialogContent style={{paddingTop: 5}}>

                    <Text
                        label="user.email"
                        value={email}
                        onChange={s_email}
                        validators={['required', 'isEmail']}
                        errorMessages={['this field is required', 'email is not valid']}/>
                    {showPhone && (
                        <TextField
                            value={phone}
                            error={!phone}
                            onChange={e => {
                                s_phone(e.target.value);
                            }}
                            label="Phone Number"
                            id="phone-login"
                            sx={{margin: "10px 0", width: '100%'}}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">+</InputAdornment>,
                                inputMode: 'numeric', pattern: '[0-9]*'
                            }}
                            type="text"
                        />
                    )}
                    <Text
                        label="user.name"
                        value={name}
                        onChange={s_name}
                        validators={['required']}
                        errorMessages={['this field is required']}/>

                    <Divider style={{marginBottom: 10}}/>

                    <Text
                        label="user.password"
                        value={password}
                        onChange={s_password}
                        type="password"
                        validators={['required']}
                        errorMessages={['this field is required']}/>
                    <Text
                        label="user.confirm_password"
                        value={confirm_password}
                        onChange={s_confirm_password}
                        type="password"
                        validators={['required']}
                        errorMessages={['this field is required']}/>

                    <Divider style={{marginBottom: 10}}/>

                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label"><Tx>user.selectRole</Tx></FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            name="radio-buttons-group"
                            value={role}
                            onChange={e => s_role(e.target.value)}
                        >
                            {allowAddUsersType.map((role, idx) => <FormControlLabel key={idx} value={role}                                   control={<Radio/>} label={
                                    <Tx>{`user.add.${role}`}</Tx>}/>)
                            }
                        </RadioGroup>
                    </FormControl>

                    {role === 'CLIENT_ADMIN' && userRole !== 'CLIENT_ADMIN' && (
                        <ClientSelectorWrapper>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Client</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={selectedClient}
                                    label="Client"
                                    onChange={(e) => s_selectedClient(e.target.value)}
                                >
                                    {clients.map(client => {
                                        return (
                                            <MenuItem
                                                key={client._id}
                                                value={client._id}>
                                                {client.name}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </ClientSelectorWrapper>
                    )}

                    {role === USER_TYPES.SITE_ADMIN && userRole === USER_TYPES.CLIENT_ADMIN && (
                        <ClientSelectorWrapper>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Site</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={selectedSite}
                                    label="Site"
                                    onChange={(e) => s_selectedSite(e.target.value)}
                                >
                                    {sites.map(site => {
                                        return (
                                            <MenuItem
                                                key={site._id}
                                                value={site._id}>
                                                {site.name}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </ClientSelectorWrapper>
                    )}


                </DialogContent>

                <DialogActions>

                    <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                    <Button
                        disabled={isSaveDisabled()}
                        autoFocus type="submit">
                        <Tx>g.save</Tx>
                    </Button>

                </DialogActions>
            </ValidatorForm>
        </Dialog>);
}